import useQuery from "./useQuery";
import { translationLocale } from "../i18n/locale";
import React from "react";

export const useAlgorithmPresets = () => {
  const rawAlgorithmPresets = useQuery("/diagnosis/presets", {
    keepFresh: true,
  }).body;
  const dicoAlgorithmPresetTranslates = useQuery("/diagnosis/presets/translations", {
    query: { lang: translationLocale },
    keepFresh: true,
  }).body;

  return React.useMemo(
    () =>
      rawAlgorithmPresets.flatMap(preset => {
        const preset_ = rawAlgorithmPresets.find(f => f.key === preset.key);
        if (preset_ === undefined) return [];

        const presetTranslate = dicoAlgorithmPresetTranslates[preset.key];

        const parameters = preset_.parameters.map(param => {
          const parameterTranslate = presetTranslate?.parameters[param.key];

          return {
            ...param,
            key: param.key,
            translateKey: parameterTranslate?.name ?? param.key,
          };
        });

        return [
          {
            key: preset.key,
            translateKey: presetTranslate?.name ?? preset.key,
            parameters,
          },
        ];
      }),
    [rawAlgorithmPresets, dicoAlgorithmPresetTranslates],
  );
};

export type AlgorithmPreset = ReturnType<typeof useAlgorithmPresets>[number];
